<template>
  <div class="content">
    <div class="headimg flex">
      <div class="img flex">
        <img src="../assets/images/avatar.png" />
        <p v-if="!username" @click="login()">请登录</p>
        <p v-if="username">Hi, {{ username }}</p>
      </div>
      <div class="button btn_recharge" @click="recharge()">
        <img src="../assets/images/nav_recharge.png" /> <span>充值</span>
      </div>
    </div>

    <div class="tips">
      <el-alert
        type="warning"
        effect="dark"
        title="您有新的客服消息未回复"
        v-if="msgshow"
        >
      </el-alert>
    </div>
    <div class="wallet">
      <div class="bg"><img src="../assets/images/bg_member.png" /></div>
      <div class="wallet_info">
        <h3>我的钱包</h3>
        <ul class="flex">
          <li><p>余额</p><b>{{ balance }}</b></li>
          <li><p>充值</p><b>{{ deposit }}</b></li>
          <li><p>出金</p><b>{{ exchange }}</b></li>
        </ul>
        <div class="warning flex" v-if="username">
          <img src="../assets/images/icon_voice.png" />
          <p>请保护好自己的账户安全，充值前请和客服确认！</p>
        </div>
      </div>
    </div>    

    <div class="member_nav">
      <h2>常用工具</h2>
      <ul>
        <li class="flex" @click="publist()">
          <div class="left flex">
            <img src="../assets/images/icon_my_pub.png" />
            <p>我的发布</p>            
          </div>
          <img src="../assets/images/right_white.png" />
        </li>
        <li class="flex" @click="record()">
          <div class="left flex">
            <img src="../assets/images/icon_recharge.png" />
            <p>充值记录</p>            
          </div>
          <img src="../assets/images/right_white.png" />
        </li>
        <li class="flex" @click="chat()">
          <div class="left flex">
            <img src="../assets/images/icon_kefu.png" />
            <p>我的客服</p>  
          </div>
          <img src="../assets/images/right_white.png" />
        </li>
        <li class="flex" @click="record2()">
          <div class="left flex">
            <img src="../assets/images/icon_wallet.png" />
            <p>资金明细</p>            
          </div>
          <img src="../assets/images/right_white.png" />
        </li>        
      </ul>
    </div>

    <button @click="logout()" v-if="username" class="logout">退出登录</button>            

    <Custom></Custom>
    <Footer activeIndex="0"></Footer>
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'
import Custom from '@/components/Custom.vue'
import { API_BASE_URL } from '../constant';
export default {
  name: 'IndexView',
  components: {
    Footer, Custom
  },
  data() {
      return {
       balance: 0.00,
       exchange: 0.00,
       deposit: 0.00,
       inviteCode : '-',
       kefu: '-',
       username: '',
       msgshow: 0,
      };
    },

  created() {
    const token = localStorage.getItem('token')
    if(!token){
      return;
    }
    this.axios.get(
        '/api/user/info', {
          headers:{
            'token': token,
          }
        }
      ).then((res)=>{
        if(res.data.code == 1){
          this.username = res.data.data.userinfo.username
          this.balance = res.data.data.userinfo.money
          this.inviteCode = res.data.data.userinfo.invite_code
          this.exchange = res.data.data.userinfo.exchange
          this.deposit = res.data.data.userinfo.deposit
          this.msgshow = !res.data.data.userinfo.reply_status
          this.kefu = res.data.data.userinfo.kefu
        }
      }).catch((res)=>{
        this.$checkError(res);
      })
  },

  //模板渲染后调用
  mounted() {
  },

  // 方法
  methods: {
    login(){
      this.$router.push({path: "/login"});
    },

    logout(){
      const token = localStorage.getItem("token");
      if(!token) return false;
      this.axios.post('/api/user/logout',{}, {
          headers: {
            'token' : token
          },
        }).then(res => {
          if(res.data.code == 1){
            localStorage.removeItem('token')
            this.username = '';
            this.balance = 0;
            this.exchange = 0;
            this.deposit = 0;
            this.inviteCode = '-';
          }
          this.$dialog(res.data.msg);
        }).catch(error => {
          console.error('Error fetching data:', error);
        });
    },

    recharge(){
      this.$router.push({path: "/recharge"});
    },

    publist(){
      this.$router.push({path: "/publist"});
    },

    chat(){
      this.$router.push({path: "/chat"});
    },

    record(){
      this.$router.push({path: "/record"});
    },

    record2(){
      this.$router.push({path: "/moneyrecord"});
    },

    //校验登录
    checkLogin(){
      const token = localStorage.getItem("token");
      if(!token){
        this.$dialog('请先登录');
        return false;
      }
      return true;
    }
  },
        
}
</script>

<style scoped>
@media screen and (max-width: 640px) {
  .logout{
    background: #1e2b5f;
    width: calc(100% - 30px);
    height: 45px;
    margin: 0 auto 40px;
    font-size: 16px;
  }
  .btn_login{
    background: #27DB9E;
  }
  .member_nav{
    width: calc(100% - 30px);
    margin: 30px auto;
    background: #1E2B5F;
    border-radius: 10px;
    padding: 20px 10px 0px 10px;
  }
  .member_nav h2{
    text-align: left;
    font-size: 18px;
  }
  .member_nav ul{
    padding-top: 10px;
  }
  .member_nav ul li{
    padding: 15px 0;
    border-bottom: 1px solid #eee;
  }
  .member_nav ul li:last-child{
    border: none;
  }
  .member_nav ul li .left img{
    height: 35px;
  }
  .member_nav ul li .left p{
    padding-left: 10px;
  }
  .member_nav ul li > img{
    height: 15px;
  }
  .content{
    padding: 0 0 60px;
    height: auto;
  }
  .headimg{
    padding: 15px;
  }
  .headimg .img img{
    width: 40px;
    height: 40px;
    border-radius: 80px;
    overflow: hidden;
    border: 3px solid #fff;
  }
  .headimg .img p{
    font-size: 16px;
    padding-left: 20px;
  }
  .btn_recharge{
    background: #1E2B5F;

  }
  .btn_recharge img{
    height: 15px;
    margin-right: 5px;
  }
  .tips{
    width: 100%;
    overflow: hidden;
    padding: 0 15px;
    border-radius: 10px;
    position: relative;
    margin-top: 20px;
  }
  .wallet{
    width: 100%;
    height: 180px;
    overflow: hidden;
    padding: 0 15px;
    border-radius: 10px;
    position: relative;
    margin-top: 20px;
  }
  .wallet .bg {
    width: 100%;
    height: 100%;
  }
  .wallet .bg img{
    width: 100%;
    height: 100%;
    display: block;
  }
  .wallet .wallet_info{
    width: 100%;
    height: 100%;
    padding: 25px 30px;
    position: absolute;
    left: 0;
    top: 0;
  }
  .wallet .wallet_info h3{
    font-size: 18px;
    text-align: left;
    font-weight: normal;
  }
  .wallet .wallet_info ul{
    padding: 20px 0;
  }
  .wallet .wallet_info ul li{
    width: 30%;
    text-align: left;
    border-right: 1px solid #fff;
  }
  .wallet .wallet_info ul li b{
    font-size: 20px;
    padding-top: 5px;
    display: block;
  }
  .wallet .wallet_info ul li:nth-child(2){
    width: 40%;
    text-align: center;
  }
  .wallet .wallet_info ul li:nth-child(3){
    text-align: center;
  }
  .wallet .wallet_info ul li:last-child{
    border: none;
  }
  .wallet .wallet_info .warning{
    justify-content: flex-start;
  }
  .wallet .wallet_info .warning img{
    height: 15px;
  }
  .wallet .wallet_info .warning p{
    font-size: 13px;
    padding-left: 5px;
  }
}
@media screen and (min-width: 640px){
  .logout{
    background: #1e2b5f;
    width: calc(100% - 30px);
    height: 55px;
    margin: 10px auto 40px;
    font-size: 16px;
  }
  .btn_login{
    background: #27DB9E;
  }
  .member_nav{
    width: calc(100% - 30px);
    margin: 30px auto;
    background: #1E2B5F;
    border-radius: 10px;
    padding: 20px 20px 0px 20px;
  }
  .member_nav h2{
    text-align: left;
    font-size: 18px;
  }
  .member_nav ul{
    padding-top: 10px;
  }
  .member_nav ul li{
    padding: 20px 0;
    border-bottom: 1px solid #eee;
    cursor: pointer;
  }
  .member_nav ul li:last-child{
    border: none;
  }
  .member_nav ul li .left img{
    height: 35px;
  }
  .member_nav ul li .left p{
    padding-left: 10px;
  }
  .member_nav ul li > img{
    height: 15px;
  }
  .content{
    width: 100%;
    margin: 0 auto;
    padding: 0 0 60px;
    height: auto;
  }
  .headimg{
    padding: 15px;
    background: #1E2B5F;
  }
  .headimg .img img{
    width: 40px;
    height: 40px;
    border-radius: 80px;
    overflow: hidden;
    border: 3px solid #fff;
  }
  .headimg .img p{
    font-size: 16px;
    padding-left: 20px;
  }
  .btn_recharge{
    background: #3EE4B2;
  }
  .btn_recharge img{
    height: 15px;
    margin-right: 5px;
  }
  .wallet{
    width: 100%;
    height: 230px;
    overflow: hidden;
    padding: 0 15px;
    border-radius: 10px;
    position: relative;
    margin-top: 20px;
  }
  .wallet .bg {
    width: 100%;
    height: 100%;
    display: none;
  }
  .wallet .bg img{
    width: 100%;
    height: 100%;
    display: block;
  }
  .wallet .wallet_info{
    width: 100%;
    height: 100%;
    padding: 25px 30px;
    position: absolute;
    left: 0;
    top: 0;
  }
  .wallet .wallet_info h3{
    font-size: 18px;
    text-align: left;
    font-weight: normal;
  }
  .wallet .wallet_info ul{
    padding: 20px 0;
  }
  .wallet .wallet_info ul li{
    width: 30%;
    text-align: center;
    background: #298DE0;
    border-radius: 10px;
    padding: 30px 0;
  }
  .wallet .wallet_info ul li b{
    font-size: 20px;
    padding-top: 5px;
    display: block;
  }
  .wallet .wallet_info ul li:nth-child(2){
    background: #E577AE;
  }
  .wallet .wallet_info ul li:nth-child(3){
    background: #3EE4B2;
  }
  .wallet .wallet_info ul li:last-child{
    border: none;
  }
  .wallet .wallet_info .warning{
    justify-content: flex-start;
  }
  .wallet .wallet_info .warning img{
    height: 15px;
  }
  .wallet .wallet_info .warning p{
    font-size: 13px;
    padding-left: 5px;
  }
}
</style>
